module.exports = __webpack_public_path__ + "media/assets/avia/ticket/moon-7a10a00c4bd0671bcba71f741529bde2.png";